import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { useNavigate } from "react-router-dom";
import { audiosAssets } from "../../../assets/audio";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstructionTeam2 } from "../../../assets/imgIntruction/tema2";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { tasksId } from "../../../types/activityTasks";
import { ModalInfo } from "../../../components/common/ModalInfo";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	panelActivity: 200,
	dialogTwo: 2,
	dialogThree: 3,
	dialogFour: 4,
	panelCounMinExhibition: 5,
	panelCountMaxExhibition: 6,
	dialogFive: 7,
	dialogSix: 8,
	dialogSeven: 9,
	dialogEight: 10,
	dialogNine: 11,
	dialogTen: 12,
	dialogEleven: 13,
	dialogTwelve: 14,
	dialogThirteen: 15,
	dialogFourteen: 16,
	dialogFifteen: 17,
	dialogSixteen: 18,
	dialogSeventeen: 19,
	dialogEighteen: 20,
	dialogNineteen: 21,
	dialogTwenty: 22,
	dialogTwentyone: 23,
	dialogCloseDoor: 31,
	//* tooltip
	tooltipContenedorDeGrano: 25,
	tooltipLlave: 26,
	tooltipPantalla: 27,
	tooltipBotonSelecion: 28,
	tooltipDispensador: 29,
	tooltipCharolaVaso: 30,
	//* tooltip two
	tooltipAzucar: 32,
	tooltipSplendar: 33,
	tooltipVaso4: 34,
	tooltipVaso12: 35,
	tooltipVaso16: 36,
	//* tooltip three
	tooltipagitadores: 37,
	tooltipvasostooltip: 38,
	tooltiptapasextras: 39,
	tooltiptapas: 40,
	tooltipportamangas: 41,
	hiddenUI: 100,
	win: 300,
};

const stepRayCaster = {
	ContenedorDeGrano: steps.tooltipContenedorDeGrano,
	CharolaPortaVaso: steps.tooltipCharolaVaso,
	BotonesDeSeleccion: steps.tooltipBotonSelecion,
	Dispensador001: steps.tooltipDispensador,
	Llave003: steps.tooltipLlave,
	Pantalla: steps.tooltipPantalla,
	Garrafon001: steps.dialogSeven,
	contenedor03Paso2001: steps.dialogNine,
	contenedor02Paso1001: steps.dialogTen,
	//* tooltip two
	azucar: steps.tooltipAzucar,
	splenda: steps.tooltipSplendar,
	vaso4: steps.tooltipVaso4,
	vaso12: steps.tooltipVaso12,
	vaso16: steps.tooltipVaso16,
	//* tooltip three
	agitadores: steps.tooltipagitadores,
	vasostooltip: steps.tooltipvasostooltip,
	tapasextras: steps.tooltiptapasextras,
	tapas: steps.tooltiptapas,
	portamangas: steps.tooltipportamangas,
};

export const Team2SubtopicTwoActivityFour = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema2.activities.subtema2], 4);
	const stepSelectRayCaster = useRef(0);

	useEffect(() => {
		if (loaded) {
			console.log('tema 2 sub 2 act 4');
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a01T2)
	})

	ObserverEmitter.on(EVENTS.team2.subtopicThree.clickedRayCaster, (step) => {
		if (step === "Llave001" && stepSelectRayCaster.current === steps.dialogNine) {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.animationKeyMachine);
			return;
		}

		const clickRayCaster = stepRayCaster[step];
		if (clickRayCaster === undefined) {
			return;
		}

		const isNextMove = stepSelectRayCaster.current === clickRayCaster;

		if (!isNextMove) {
			return;
		}

		// console.log('click', step);

		if (clickRayCaster === steps.tooltipContenedorDeGrano) {
			hiddenSelectObject(steps.tooltipLlave);
		}
		if (clickRayCaster === steps.tooltipLlave) {
			hiddenSelectObject(steps.tooltipPantalla);
		}
		if (clickRayCaster === steps.tooltipPantalla) {
			hiddenSelectObject(steps.tooltipBotonSelecion);
		}
		if (clickRayCaster === steps.tooltipBotonSelecion) {
			hiddenSelectObject(steps.tooltipDispensador);
		}
		if (clickRayCaster === steps.tooltipDispensador) {
			hiddenSelectObject(steps.tooltipCharolaVaso);
		}
		if (clickRayCaster === steps.tooltipCharolaVaso) {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a02T2)
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.tooltip.hiddenTooltip);
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.visibilityCupWhite);
			stepSelectRayCaster.current = 0;
			setUiToShow(steps.dialogThree);
		}

		//? animacion de paso 1
		if (clickRayCaster === steps.dialogSeven) {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.animatioGarrafon, steps.dialogSeven);
		}
		//? animacion de paso 2
		if (clickRayCaster === steps.dialogNine) {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a07T2)
			stepSelectRayCaster.current = 0;
			setUiToShow(steps.dialogNine);
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepFour);
		}

		if (clickRayCaster === steps.dialogTen) {
			stepSelectRayCaster.current = 0;
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a08T2)
			setUiToShow(steps.dialogTen);
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.visibleContainerStepFour);
		}

		//? tootip two
		if (clickRayCaster === steps.tooltipAzucar) {
			hiddenSelectObject(steps.tooltipSplendar);
		}
		if (clickRayCaster === steps.tooltipSplendar) {
			hiddenSelectObject(steps.tooltipVaso4);
		}
		if (clickRayCaster === steps.tooltipVaso4) {
			hiddenSelectObject(steps.tooltipVaso12);
		}
		if (clickRayCaster === steps.tooltipVaso12) {
			hiddenSelectObject(steps.tooltipVaso16);
		}
		if (clickRayCaster === steps.tooltipVaso16) {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.finishStep);
			stepSelectRayCaster.current = 0;
			setUiToShow(steps.dialogTwenty);
		}

		//? tootip three
		if (clickRayCaster === steps.tooltipagitadores) {
			hiddenSelectObject(steps.tooltipvasostooltip);
		}
		if (clickRayCaster === steps.tooltipvasostooltip) {
			hiddenSelectObject(steps.tooltiptapasextras);
		}
		if (clickRayCaster === steps.tooltiptapasextras) {
			hiddenSelectObject(steps.tooltiptapas);
		}
		if (clickRayCaster === steps.tooltiptapas) {
			hiddenSelectObject(steps.tooltipportamangas);
		}
		if (clickRayCaster === steps.tooltipportamangas) {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a18T2)
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.finishStep);
			stepSelectRayCaster.current = 0;
			setUiToShow(steps.dialogTwentyone);
		}
	});

	//* observadores de aninacion
	ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.animationKeyMachineFinish, (step) => {
		ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.moveMachineContainer);
		ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepThree);
	});

	ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.animatioGarrafonFinish, (step) => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a05T2)
		ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.visibleunCuartoAct3);
		stepSelectRayCaster.current = 0;
		setUiToShow(step);
	});

	ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.containerStepFourFinish, (step) => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a09T2)
		stepSelectRayCaster.current = 0;
		setUiToShow(step);
		ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.moveMachineKey);
	});

	ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.containerStepSevenFinish, (step) => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a10T2)
		stepSelectRayCaster.current = 0;
		setUiToShow(step);
	});

	ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.showConetenedorFinish, (step) => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a16T2)
		stepSelectRayCaster.current = 0;
		setUiToShow(step);
	});

	ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.saveContenedorFinish, (step) => {
		stepSelectRayCaster.current = 0;
		setUiToShow(step);
	});

	//* observadores de aninacion

	const activeEffectScene = (value) => {
		// console.log(value);
		if (value === "ContenedorDeGrano") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.tooltip.containerGrain);
		}
		if (value === "CharolaPortaVaso") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.tooltip.charolaVaso);
		}
		if (value === "BotonesDeSeleccion") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.tooltip.botonselecion);
		}
		if (value === "Dispensador001") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.tooltip.dispensador);
		}
		if (value === "Llave003") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.tooltip.llave);
		}
		if (value === "Pantalla") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.tooltip.pantalla);
		}
		if (value === "Llave001") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.moveMachineKey);
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepTwo);
		}
		if (value === "Garrafon001") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepOne);
		}
		if (value === "contenedor02Paso1001") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepFive);
		}
		if (value === "moveContainerCoffe") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepSix, steps.dialogEleven);
		}
		if (value === "closeContainerCoffe") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepSeven, steps.dialogCloseDoor);
		}

		if (value === "moveParrillasClean") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.showConetenedorInit, steps.dialogSeventeen);
		}

		if (value === "saveParrillasClean") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.saveContenedorInit, steps.dialogNineteen);
		}

		//? tootip two
		if (value === "azucar") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.moveMachineLimpieza);
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.azucar);
		}
		if (value === "splenda") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.splenda);
		}
		if (value === "vaso4") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.vaso4);
		}
		if (value === "vaso12") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.vaso12);
		}
		if (value === "vaso16") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.vaso16);
		}

		//? tootip three
		if (value === "agitadores") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.initStep);
		}
		if (value === "vasostooltip") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.vasostooltip);
		}
		if (value === "tapasextras") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.tapasextras);
		}
		if (value === "tapas") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.tapas);
		}
		if (value === "portamangas") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.portamangas);
		}
	};

	// parte uno de animaciones ----
	const hiddenKey = (stepCaster = 0) => {
		activeEffectScene("Llave001");
		ObserverEmitter.emit(EVENTS.team2.subtopicThree.stepUseRayCaster, "Llave001");
		stepSelectRayCaster.current = stepCaster;
		setUiToShow(steps.hiddenUI);
	};

	const hiddenContainerCoffe = (stepCaster = 0) => {
		activeEffectScene("moveContainerCoffe");
		stepSelectRayCaster.current = stepCaster;
		setUiToShow(steps.hiddenUI);
	};

	const hiddenCloseCoffe = (stepCaster = 0) => {
		activeEffectScene("closeContainerCoffe");
		stepSelectRayCaster.current = stepCaster;
		setUiToShow(steps.hiddenUI);
	};
	// parte uno de animaciones ----

	// parte dos de animaciones ----
	const hiddenAnimationParrillas = (stepCaster = 0) => {
		activeEffectScene("moveParrillasClean");
		stepSelectRayCaster.current = stepCaster;
		setUiToShow(steps.hiddenUI);
	};
	const hiddenAnimationSaveParrillas = (stepCaster = 0) => {
		activeEffectScene("saveParrillasClean");
		stepSelectRayCaster.current = stepCaster;
		setUiToShow(steps.hiddenUI);
	};
	// parte dos de animaciones ----

	const hiddenSelectObject = (stepCaster = 0) => {
		const foundEntry = Object.entries(stepRayCaster).find(([key, value]) => value === stepCaster);
		if (!foundEntry) {
			console.log("no se encontro");
			return;
		}
		const [key] = foundEntry;
		activeEffectScene(key);
		ObserverEmitter.emit(EVENTS.team2.subtopicThree.stepUseRayCaster, key);
		stepSelectRayCaster.current = stepCaster;
		setUiToShow(steps.hiddenUI);
	};

	// console.log('ui', uiToShow);

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2, steps.hiddenUI, 11, 12, 13, 31].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.initScene, 3);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 4: Maquina Kobalto" />
					<DialogBarNew
						dialog={"¡Bien hecho! También tenemos nuestra maquina Kobalto, es momento de hablar de su modo de operación."}
						percentage={"5%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.moveMachineCoffe);
							setUiToShow(steps.panelActivity);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivity && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquinas de café"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<PanelInstrucionHands
						text="Explora tocando las etiquetas."
						action={() => {
							hiddenSelectObject(steps.tooltipContenedorDeGrano);
						}}
						img={imgInstructionTeam2.team2_sub2_act_4_01}
					/>
				</>
			)}


			{uiToShow === steps.dialogThree && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={"También deberas conocer el vaso exclusivo para la maquina, lo podrás identificar por su particular color blanco."}
						percentage={"15%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a03T2)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<DialogBarNew
					dialog={"En caso de las cantidades mínimas y máximas de exhibición son las siguientes:"}
					percentage={"20%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.hiddenCupWhite);
						setUiToShow(steps.panelCounMinExhibition);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.panelCounMinExhibition && (
				<>
					<ModalInfo
						title="Cantidades mínimas de exhibición"
						action={() => {
							setUiToShow(steps.panelCountMaxExhibition);
						}}
					>
						{["250 gr de Vainilla", "250 gr de Café", "250 gr de Leche", "140 gr de Chocolate"].map((point, index) => (
							<li key={`${index}-pointmodelinfo`} className="list-disc mt-1">
								{point}
							</li>
						))}
					</ModalInfo>
				</>
			)}
			{uiToShow === steps.panelCountMaxExhibition && (
				<>
					<ModalInfo
						title="Cantidades máximas de exhibición"
						action={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a04T2)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialogFive);

						}}
					>
						{["1000 gr de Vainilla", "1000 gr de Café", "1000 gr de Leche", "560 gr de Chocolate"].map((point, index) => (
							<li key={`${index}-pointmodelinfo`} className="list-disc mt-1">
								{point}
							</li>
						))}
					</ModalInfo>
				</>
			)}
			{uiToShow === steps.dialogFive && (
				<>
					<HeaderRedPresentation name="Actividad 4: Maquina Kobalto" />
					<DialogBarNew
						dialog={"La manera de iniciar su operación es muy similar a lo que ya conoces."}
						percentage={"25%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.moveTableCoffe);
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							hiddenSelectObject(steps.dialogSeven);
							// setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}
			{/* {uiToShow === steps.dialogSix && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={"Presiona sobre los lugares iluminados para conocer sus pasos y características."}
						percentage={"30%"}
						callback={() => {
							hiddenSelectObject(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)} */}
			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={"Paso 1: verifica el que el garrafón tenga al menos ¼ de agua. La manguera debe estar por debajo de este nivel"}
						percentage={"35%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a06T2)
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.hiddenGarrafon);
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.hiddenunCuartoAct3);
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogEight && (
				<DialogBarNew
					dialog={"Paso 2: gira la llave y estira la tapa hacia ti. Levanta la tapa que esta arriba de los contenedores de polvo."}
					percentage={"40%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						hiddenKey(steps.dialogNine);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						dialog={
							"Paso 3: recuerda verificar el nivel del polvo para cada contenedor: retiralo de la maquina y agítalo para verificar el nivel real."
						}
						percentage={"45%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							hiddenSelectObject(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						dialog={
							"Paso 4: coloca los contenedores en su lugar asegurándote de que la parte trasera encaje con la máquina. Gira el codo del paso de polvo hacia abajo, apuntando hacia el embudo."
						}
						percentage={"50%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							hiddenContainerCoffe(steps.dialogEleven);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogEleven && (
				<DialogBarNew
					dialog={"Paso 5: Baja la tapa que se encuentra arriba de los contenedores"}
					percentage={"55%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						hiddenCloseCoffe(steps.dialogCloseDoor);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogCloseDoor && (
				<DialogBarNew
					dialog={"Cierra la máquina, verifica que esto sea correcta girando la llave."}
					percentage={"60%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a11T2)
						setUiToShow(steps.dialogTwelve);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.moveMachineContainer);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.finishCafeteraKobaltoProceso);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogTwelve && (
				<>
					<HeaderRedPresentation name="Actividad 4: Limpieza" />
					<DialogBarNew
						dialog={
							"¡Bien hecho! Sin embargo, recuerda que una de las actividades más importantes es la limpieza. A continuación, te mostraremos el proceso."
						}
						percentage={"65%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a12T2)
							setUiToShow(steps.dialogThirteen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThirteen && (
				<DialogBarNew
					dialog={"Descubre a fondo el proceso de limpieza de la Máquina Kobalto y conoce todos los detalles."}
					percentage={"70%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a13T2)
						setUiToShow(steps.dialogFourteen);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.trapo);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogFourteen && (
				<DialogBarNew
					dialog={
						"Limpia con un trapo húmedo todas las paredes externas (paredes, piso, puerta, tapa, debajo y en la parte superior de la maquina)."
					}
					percentage={"75%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a14T2)
						setUiToShow(steps.dialogFifteen);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.papel);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogFifteen && (
				<DialogBarNew
					dialog={"Seca con papel secante. Asegúrate de limpiar la superficie por debajo del equipo."}
					percentage={"80%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a15T2)
						setUiToShow(steps.dialogSixteen);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.moveMachineCleanKobalto);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogSixteen && (
				<DialogBarNew
					dialog={
						"Retira las parrillas portavasos, tira el exceso de residuos y enjuaga con agua y liquido multiusos. Seca con papel secante"
					}
					percentage={"85%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						hiddenAnimationParrillas(steps.dialogSeventeen);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogSeventeen && (
				<DialogBarNew
					dialog={"Estira las pestañas de la puerta para sacar el contenedor azul y luego tira los residuos de café."}
					percentage={"90%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act4_a17T2)
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.removeCoffeContainer);
						setUiToShow(steps.dialogEighteen);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogEighteen && (
				<DialogBarNew
					dialog={
						"Lávalo con multiusos, enjuaga con agua y colocando en la misma posición asegurándote de que todas las piezas estén en su lugar para el correcto funcionamiento."
					}
					percentage={"95%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						hiddenAnimationSaveParrillas(steps.dialogNineteen);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogNineteen && (
				<>
					<PanelInstrucionHands
						text="Explora tocando las etiquetas."
						action={() => {
							hiddenSelectObject(steps.tooltipAzucar);
						}}
						img={imgInstructionTeam2.team2_sub2_act_4_01}
					/>
				</>

			)}
			{uiToShow === steps.dialogTwenty && (
				<>
					<PanelInstrucionHands
						text="Explora tocando las etiquetas."
						action={() => {
							hiddenSelectObject(steps.tooltipagitadores);
						}}
						img={imgInstructionTeam2.team2_sub2_act_4_01}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwentyone && (
				<DialogBarNew
					dialog={
						"¡Gran trabajo! Manejaste la máquina Kobalto con maestría. Esta es solo una de nuestras innovadoras ofertas para los clientes. ¡Hay mucho más por descubrir!"
					}
					percentage={"100%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						setUiToShow(steps.win)
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.win && (
				<ValidationResultModal
					title="¡Bien hecho!"
					dialogModal="La máquina de Kobalto se distingue por su mantenimiento detallado, se cuidadoso y recuerda cada paso."
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 4,
								pointsWin: 0,
								subtema: tasksId.tema2.activities.subtema2,
							})
						);
						navigator("/home2/tema2/subtema2/activityFive");
					}}
				/>
			)}
		</>
	);
};
